import { render, staticRenderFns } from "./OrdersTableOrderItem.vue?vue&type=template&id=4048153a&scoped=true&"
import script from "./OrdersTableOrderItem.vue?vue&type=script&lang=js&"
export * from "./OrdersTableOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTableOrderItem.vue?vue&type=style&index=0&id=4048153a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048153a",
  null
  
)

export default component.exports